import { Directive, HostBinding } from '@angular/core';


@Directive({
    selector: 'i.fa'
})
export class FaIconDirective {

    @HostBinding('attr.aria-hidden') ariaHidden = 'true';
}
